import React from "react";
import { t } from "ttag";

import { ServerCmsTypesCategoryNavItem } from "@reactivated";

import { ImageChooserBlock } from "@thelabnyc/thelabui/src/components/ImageChooserBlock";

import { Themed } from "../../styles/themes";
import { Carousel } from "../Carousel/Carousel";
import { Clickable } from "../Clickables";
import { SKSDots } from "../SKSCarousel/Dots";

import breakpoint from "../../styles/breakpoint.module.scss";
import styles from "./index.module.scss";

const DESKTOP_VISIBLE = 5;
const MOBILE_VISIBLE = 2;

const imageSizes = [
    `(min-width: ${breakpoint.mobile}) ${Math.round(100 / DESKTOP_VISIBLE)}vw`,
    `${Math.round(100 / MOBILE_VISIBLE)}vw`,
].join(", ");

const Tile = ({ tile }: { tile: ServerCmsTypesCategoryNavItem }) => (
    <Themed tag="div" theme="darkThemeText">
        <Clickable href={tile.url} className={styles.tile}>
            {tile.image && (
                <ImageChooserBlock
                    value={tile.image}
                    attrs={{ className: styles.picture }}
                    // These are decorative images
                    imageAttrs={{ className: styles.image, alt: "" }}
                    sizes={imageSizes}
                />
            )}
            <span className={styles.label}>{tile.title}</span>
        </Clickable>
    </Themed>
);

export const SubcategoryTiles = ({
    tiles,
    categoryTitle,
}: {
    tiles: ServerCmsTypesCategoryNavItem[];
    categoryTitle: string;
}) => {
    if (tiles.length === 0) return <></>;

    return (
        <Themed
            tag="div"
            theme="offWhite"
            className={styles.root}
            style={{
                "--tiles-visible-desktop": DESKTOP_VISIBLE,
                "--tiles-visible-mobile": MOBILE_VISIBLE,
            }}
        >
            <Carousel
                label={t`${categoryTitle} Categories`}
                scrollContainerProps={{ className: styles.scrollContainer }}
                slideWrapperProps={{ className: styles.slideWrapper }}
                slideContainerProps={{ className: styles.slideContainer }}
                controls={null}
                dots={(props) => <SKSDots {...props} className={styles.dots} />}
            >
                {tiles.map((tile) => (
                    <Tile key={tile.url} tile={tile} />
                ))}
            </Carousel>
        </Themed>
    );
};
